const caretUp = "data:image/svg+xml,%3csvg%20viewBox='0%200%2010%206'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.34938%200.274497C4.70006%20-0.0914993%205.29994%20-0.0914989%205.65062%200.274498L9.76313%204.56662C10.2872%205.11355%209.88482%206%209.11252%206L0.887482%206C0.115184%206%20-0.287178%205.11355%200.236866%204.56662L4.34938%200.274497Z'%20fill='%23212529'/%3e%3c/svg%3e";
export {
  caretUp as default
};
